import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class AfiliacionService
{
    constructor(public http: HttpClient, ) { }
                                                     
    traeAfiliado(rut: any)
    {   
      return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeAfiliadoSinEstados(rut: any)
    {   
      return this.http.get(`${environment.urlBase}/afiliados/rutEstados/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }
    
    traeSoloAfiliadoSinEstados(rut: any)
    {   
      return this.http.get(`${environment.urlBase}/afiliados/rutEstadosSoloAfiliado/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }
    
    validaAfiliadoPorRut(rut: any, existe:boolean)
    {
      return this.http.get(`${environment.urlBase}/afiliados/validaAfiliadoPorRut/${rut}/validarSiYaExiste/${existe}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    retornaAfiliadoPorUsername(username: any)
    {   
      return this.http.get(`${environment.urlBase}/afiliados/email/${username}`,
               { headers: this.armaCabecera() }).toPromise();
    }
  
    traeAfiliadoGesdep(rut: any)
    {   
	  rut=rut.toUpperCase();
      return this.http.get(`${environment.urlApiCoreservice}/getResDatosBienestarFuncionarioByRut?rut=${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }

  
    aprobarSolicitud(rut: any,fechaAfiliacion: any  , idEjecutivo: any) {

     
        return this.http.post(`${environment.urlApiAfiliacion}/v1/solicitud/aprobar`,
            {
                idEjecutivo: idEjecutivo,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1],
                fechaAfiliado: fechaAfiliacion

            },
            { headers: this.armaCabecera() }).toPromise();
           
    }

    afiliarFuncionario(rut: any,fechaAfiliacion: any  , idEjecutivo: any) {
     
      
        return this.http.post(`${environment.urlApiAfiliacion}/v1/funcionario/afiliar`,
            {
                idEjecutivo: idEjecutivo,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1],
                fechaAfiliado: fechaAfiliacion

            },
            { headers: this.armaCabecera() }).toPromise();
           
    }

    rechazarSolicitud(rut: any,fechaAfiliacion: any ,motivo: any, idEjecutivo: any) {

        return this.http.post(`${environment.urlApiAfiliacion}/v1/solicitud/rechazar`,
            {
                idEjecutivo: idEjecutivo,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1],
                fechaAfiliado: fechaAfiliacion,
                motivoRechazo:motivo
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    rechazarDesafiliacion(rut: any, fechaAfiliacion: any, idEjecutivo: any) {

        return this.http.post(`${environment.urlApiAfiliacion}/v1/afiliado/rechazarDesafiliacion`,
            {
                idEjecutivo: idEjecutivo,
                fechaAfiliado: fechaAfiliacion,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1]
            },
            { headers: this.armaCabecera() }).toPromise();
    }
    
    desafiliarAfiliado(rut: any,fechaDesafiliacion: any ,motivo: any, idEjecutivo: any) {

        return this.http.post(`${environment.urlApiAfiliacion}/v1/afiliado/desafiliar`,
            {
                idEjecutivo: idEjecutivo,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1],
                fechaDesafiliacion: fechaDesafiliacion,
                motivoDesafiliacion:motivo
            },
            { headers: this.armaCabecera() }).toPromise();
    }
   
    pendienteDesafiliacion(rut: any,motivo: any, tipoRazon: any, idEjecutivo: any) {
    
        return this.http.post(`${environment.urlApiAfiliacion}/v1/afiliado/respaldoPendientedesafiliacion`,
            {
                idEjecutivo: idEjecutivo,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1],
                razonDesafiliar:tipoRazon, 
                motivoDesafiliacion:motivo
            },
            { headers: this.armaCabecera() }).toPromise();
    }


    aprobarDesafiliacionAfiliado(rut: any) {

        return this.http.post(`${environment.urlApiAfiliacion}/v1/afiliado/aprobarDesafiliacionAfiliado`,
            {    
                rut:rut         
                /*rut:rut.split('-')[0],
                dv: rut.split('-')[1]
                */
            },
            { headers: this.armaCabecera() }).toPromise();
    }



    cambiarAfiliadoPensionado(rut: any, idEjecutivo: any,fechaAfiliacion: any,id: any) {
    
        return this.http.post(`${environment.urlApiAfiliacion}/v1/afiliado/CambiarAfiliadoPensionado`,
            {
                idEjecutivo: idEjecutivo,
                id: id,
                rut:rut.split('-')[0],
                dv: rut.split('-')[1],
                fechaAfiliado: fechaAfiliacion         
            },
            { headers: this.armaCabecera() }).toPromise();
    }
    


    guardar(id: any,observacion: any,idEjecutivo: any) {

        return this.http.post(`${environment.urlApiAfiliacion}/v1/solicitud/guardarObservacion`,
            {
                ejecutivoId: idEjecutivo,
                usuarioId: id,
                observacion: observacion

            },
            { headers: this.armaCabecera() }).toPromise();
    }
   
    ingresarSolicitudAfiliacion(rut: any) {

        return this.http.post(`${environment.urlApiSubsidio}/solicitud/matrimonio`,
            {
                idUsuario: 1,
                rut:rut

            },
            { headers: this.armaCabecera() }).toPromise();
    }

    actualizaAfiliadoDesdeGesdep(rut: any) {

        return this.http.get(`${environment.urlApiAfiliacion}/v1/actualizar/gesdep/${rut}`,
                { headers: this.armaCabecera() }).toPromise();
    }

    cargarAfiliadoenRabbit(rut: any) {
        return this.http.post(`${environment.urlApiUpload}/cargar/afiliado`,
            {
                afiliado: rut
            },
            { headers: this.armaCabecera() }).toPromise();
    }
 

    traeFormularioClaveUnica(code: any,state: any){
        return this.http.get(`${environment.urlApiClaveUnica}/clave/obtieneAccessToken/${code}/clave/${state}`,
          
            { headers: this.armaCabecera() }).toPromise();
    }

    logoutClaveUnica(){
        return this.http.get(`${environment.urlClaveUnicaLogout}`,
          
            { headers: this.armaCabeceraClaveUnica() }).toPromise();
    }

    retornaDatosPorToken(token){
        return this.http.get(`${environment.urlApiClaveUnica}/clave/obtieneDatosPersonales/${token}`,
        { headers: this.armaCabecera() }).toPromise();
    }


    retornaExcelPendientes(){
      
        return this.http.get(`${environment.urlApiAfiliacion}/v1/pendientes`,
        { headers: this.armaCabecera() }).toPromise();
    }

    retornaExcelPendientesDesafiliacion(){      
        return this.http.get(`${environment.urlApiAfiliacion}/v1/pendientesDesafiliacion`,
        { headers: this.armaCabecera() }).toPromise();
    }

    retornaExcelCargaAfiliados(fecha: any){      
        return this.http.get(`${environment.urlApiAfiliacion}/v1/excelCargaAfiliados/${fecha}`,
        { headers: this.armaCabecera() }).toPromise();
    }

    enviarTXaPS(fecha: any){      
        return this.http.get(`${environment.urlApiAfiliacion}/v1/enviarTXaPS/${fecha}`,
        { headers: this.armaCabecera() }).toPromise();
    }

    

    getFileNameUrl(file){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/status/${file}`,
        { headers: this.armaCabecera() }).toPromise();

    }
    traeBancos(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getBancos`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeTipoCuentas(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getTipoCuentas`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeNacionalidades(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getNacionalidad`,
               { headers: this.armaCabecera() }).toPromise();
    }

   
    traeEstadoCivil(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getEstadoCivil`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeSistemaSalud(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getSistemaSalud`,
               { headers: this.armaCabecera() }).toPromise();
    }
    getTipoPension(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getTipoPension`,
               { headers: this.armaCabecera() }).toPromise();
    }
    getEntidadPension(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getEntidadPension`,
               { headers: this.armaCabecera() }).toPromise();
    }

    getModalidadPension(){
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getModalidadPension`,
               { headers: this.armaCabecera() }).toPromise();
    }
    
    getRazonesDesafiliar() {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getRazonesDesafiliar`,
            { headers: this.armaCabecera() }).toPromise();
    }

    getObservacionesUsuario(rut) {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getObservacionesUsuario/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }

    traeCuotasPagadas(idAfiliado) {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/getCuotasPagadasUsuario/${idAfiliado}`,
            { headers: this.armaCabecera() }).toPromise();
    }


    
    crearGuardarAfiliado(afiliado: Afiliado, accion: any, entidad: any) {
       
        return this.http.post(`${environment.urlApiAfiliacion}/v1/afiliado/crearGuardar`,
            {
                id:afiliado.id,
                rut:afiliado.rut.split('-')[0],
                dv:afiliado.rut.split('-')[1],
                apellidoMaterno:afiliado.apellidoMaterno,
                nombres:afiliado.nombres,
                apellidoPaterno:afiliado.apellidoPaterno,            
                telefonoFijo:afiliado.telefonoFijo,
                telefonoMovil:afiliado.telefonoMovil,
                tipoAfiliado:afiliado.tipoAfiliado,
                idSexo:afiliado.idSexo,
                idNacionalidad:afiliado.idNacionalidad,
                idEstadoCivil:afiliado.idEstadoCivil,
                idSistemaSalud:afiliado.idSistemaSalud,
                bancoCodigo:afiliado.bancoCodigo,
                fechaAfiliado:afiliado.fechaAfiliacion.split('-')[2] + '-' + afiliado.fechaAfiliacion.split('-')[1] + '-' + afiliado.fechaAfiliacion.split('-')[0],
                fechaNacimiento:afiliado.fechaNacimiento.split('-')[2] + '-' + afiliado.fechaNacimiento.split('-')[1] + '-' + afiliado.fechaNacimiento.split('-')[0],
                email:afiliado.email,
                emailPersonal:afiliado.emailPersonal,
                accion:accion,   
                entidad:entidad,             
                direccion: {
                    descripcion:afiliado.direccion,
                    idRegion:afiliado.idRegion,
                    numero:afiliado.numero,
                    idComuna:afiliado.idComuna,
                    descripcionAdicional:afiliado.descripcionAdicional
                },
                datosBancarios: {
                    numeroCuenta:afiliado.numeroCuenta,
                    idBanco:afiliado.bancoCodigo,
                    idTipoCuenta:afiliado.tipoCuentaCodigo
                },
                datosPensiones: {
                    montoPension:afiliado.montoPension,
                    tipoPension:afiliado.tipoPension,
                    entidadPension:afiliado.entidadPension,
                    modalidadPension:afiliado.modalidadPension
                }
            },
            { headers: this.armaCabecera() }).toPromise();
    }


    pagosDisponiblesBuscador(usuario: any,rol:any,buscador:any,email:any){
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagosDisponibles/buscador/`,
        {
           // id:usuario,
            email: email,
            rol:rol,
            idRegion:buscador?.region,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            id: buscador?.idSolicitud,         
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado
        }, 
        { headers: this.armaCabecera() }).toPromise();
    }


    traePostulacionesAsignadas(usuario:any,buscador:any){
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/asignados/ejecutivos/id/`,
        {
            
            idUsuarioAsig: usuario,
            usuarioId: usuario,            
            id: buscador?.id,
            rut: buscador?.rut,
            idRegion:buscador?.region,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage
        },
        { headers: this.armaCabecera() }).toPromise();
    }

    asignaPostulacion(idCuota: any, idEjecutivo: any)
    {   
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/asignar/ejecutivo/${idEjecutivo}/cuota/${idCuota}`
        , { headers:this.armaCabecera() } ).toPromise()
    }

    asignaPostulaciones(postulaciones: any, idEjecutivo: any)
    {   
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }

    buscarPago(id: any)
    {   
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/buscar/${id}`
        , { headers:this.armaCabecera() } ).toPromise()
    }
    
    rechazarPago(usuarioId: any, id: any) {
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/rechazar/${id}`,
           /* {   
                usuarioId: usuarioId,
                id: id
            },*/
            { headers: this.armaCabecera() }).toPromise();
    }

    editarPago(id: any, ejecutivoId:any, data: any, fechaPago: any) {
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/editar`,
            {   
                ejecutivoId: ejecutivoId,
                id: id,
                fechaPago:fechaPago,
                monto:data.monto
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    aprobarPago(id: any, ejecutivoId:any, fechaPago: any) {
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/aprobar`,
            {   
                ejecutivoId: ejecutivoId,
                id: id,
                fechaPago:fechaPago
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    pensionadoPorRut(rut: any)
    {   
      return this.http.get(`${environment.urlApiAfiliacion}/v1/afiliados/pensionado/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/pagos/estados`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeCuotaAPagar(id: any)
    {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/traeCuotaAPagar/${id}`,
        { headers: this.armaCabecera() }).toPromise();
    }

    ingresarPago(idEjecutivo: any, pago: any ) {

        return this.http.post(`${environment.urlApiAfiliacion}/v1/solicitud/pago`,
        {
            id: pago.id,
            usuarioIdPagaCuota: idEjecutivo,
            archivoAdjunto: pago.archivo[0],
            montoTotalCuota: pago.montoCuota

        },
            { headers: this.armaCabecera() }).toPromise();
    }
    
    traeArchivos(id: any)
    {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/pagocuota/${id}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    rechazarPagoCuota(usuarioId: any, id: any, idMotivo: any, motivo: any, comentarioRechazo: any) {
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/rechazar/`,
            {
                id: id,
                usuarioId: usuarioId,
                idMotivoRechazo: idMotivo,
                motivoRechazo: comentarioRechazo
            },
            { headers: this.armaCabecera() }).toPromise();
    }

  
    
    anularReversarCuota(idCuota: any, motivoAnulacion: any,usuarioId: any) {
        return this.http.post(`${environment.urlApiAfiliacion}/v1/pagos/anularReversar/`,
            {
                id: idCuota,
                usuarioId: usuarioId,
                motivoAnulacion: motivoAnulacion
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    traePostulaciones()
    {
        return  this.http.get(`${environment.urlApiAfiliacion}/v1/afiliados/pendientes`, 
                { headers: this.armaCabecera() } ).toPromise()
    }

    
    creaGrupoAfiliado(fechaPago: any, idUsuarioAgrupa: any, postulaciones: any)
    {       
 
        return  this.http.post(`${environment.urlApiAfiliacion}/v1/agrupaciones/afiliados`, 
                {
                    fechaPagoEstimada: fechaPago,
                    usuarioId: idUsuarioAgrupa,
                    postulacion: postulaciones
                }, 
                { headers: this.armaCabecera() } ).toPromise()
    }


    traeDocumentos(id: any)
    {
        return this.http.get(`${environment.urlApiAfiliacion}/v1/traeDocumentos/${id}`,
        { headers: this.armaCabecera() }).toPromise();
    }

  
    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
            
        });
    }

    armaCabeceraClaveUnica()
    {
        return new HttpHeaders({
            'Content-Type':'text/html; charset=utf-8',
         //   'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
         //   'Access-Control-Allow-Methods': 'GET',
          //  'Access-Control-Allow-Origin': '*',
          //  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        });
    }

}